module.exports = __webpack_public_path__ + "img/frame (26).83dc6d56.jpg";